import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER, GENERAL_WHATSAPP_MESSAGE } from "@/lib/constants";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(GENERAL_WHATSAPP_MESSAGE)}`;
  return (
    <a
      data-testid="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with R&J Dry Cleaners on WhatsApp"
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 sm:bottom-7 sm:right-7"
    >
      <span className="hidden max-w-0 overflow-hidden whitespace-nowrap border border-[#25D366]/40 bg-[#F9F6F0]/90 text-[11px] font-medium uppercase tracking-[0.22em] text-[#1A1A1A] opacity-0 backdrop-blur-md transition-[max-width,opacity,padding] duration-500 ease-out group-hover:max-w-[200px] group-hover:px-4 group-hover:py-2.5 group-hover:opacity-100 sm:block">
        Chat with us
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_35px_rgba(37,211,102,0.35)] transition-transform duration-300 group-hover:scale-110">
        <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-35" />
        <MessageCircle className="relative h-6 w-6" strokeWidth={1.75} />
      </span>
    </a>
  );
}
